import { createClient } from "@sanity/client";
// import { SanityClient } from '@sanity/client/sanityClient';
import imageUrlBuilder from '@sanity/image-url';



export const client = createClient({
  projectId: "012x74az",
  dataset: "production",
  apiVersion: "2024-02-28",
  useCdn: true,
  token:"skGywOf1oxh8zJhZnYKHyU5iTje8NnCbAizGC5B90EI9mPUtzBJr6MFfUXIwbedWDDpwy96ZDjlPsl8W30fq22wL3jFZEqRwaTyAqLSvhi5h9vvBFEtPpvMLsB650wNsAWS7n0zT00rdXdZbhvPiU6BvNOeU66cJ4fUbutZrkSHlw4OYugkc"
});


const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);